module.exports = __webpack_public_path__ + "img/spring_trip-20160416-15.bb10c349.jpg";